export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f750ad7ea3bc72e30b511510f82c57ff8104f20cb&name=sendEvent!'